export const DB_DATE_FORMAT = "YYYY-MM-DD";
export const DB_TIME_FORMAT = "H:mm";
export const DEFAULT_TIME_FORMAT = "h:mm a";
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_DATETIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
export const DEFAULT_TIMEZONE = "America/Los_Angeles";
export const WENT_WRONG = "Something went wrong. Please try again later.";
export const COMB_LOGO_SRC = "/comb.svg";
export const LOGO_SRC = "/logo.png";

export const OPENINGS_EDDIES_HANDLE =
  process.env.NEXT_PUBLIC_OPENINGS_EDDIES_HANDLE ?? "eddiesedition";
export const OPENINGS_EDITION_STUDIO_HANDLE =
  process.env.NEXT_PUBLIC_OPENINGS_EDITION_STUDIO_HANDLE ?? "editionstudio";
export const OPENINGS_PASADENA_SCHEDULE_ID =
  process.env.NEXT_PUBLIC_OPENINGS_PASADENA_SCHEDULE_ID ??
  "cmmnrwtj7001004js5qokcapw";
export const OPENINGS_SAN_GABRIEL_SCHEDULE_ID =
  process.env.NEXT_PUBLIC_OPENINGS_SAN_GABRIEL_SCHEDULE_ID ??
  "cmmns53xo002j04jsdz1g8awy";
export const OPENINGS_ARTDISTRICT_SCHEDULE_ID =
  process.env.NEXT_PUBLIC_OPENINGS_ARTDISTRICT_SCHEDULE_ID ??
  "cmmnsdhlb002r04jsit14jmpn";
export const OPENINGS_MID_WILSHIRE_SCHEDULE_ID =
  process.env.NEXT_PUBLIC_OPENINGS_MID_WILSHIRE_SCHEDULE_ID ??
  "cmmnsibjl003004jsywe5uou1";
export const OPENINGS_EDITION_STUDIO_SCHEDULE_ID =
  process.env.NEXT_PUBLIC_OPENINGS_EDITION_STUDIO_SCHEDULE_ID ??
  "cmm57wwhr000004k0dngl6dz5";
